import gql from 'graphql-tag';

export const FeedFollowMutation = gql`
	mutation FeedFollowMutation($follow: [ID], $unfollow: [ID]) {
		setFeedUserConfig(input: { followUsers: $follow, unfollowUsers: $unfollow }) {
			success
		}
	}
`;
